/**
 * @file
 * Icon grabbed from Figma
 * https://www.figma.com/file/wquwuTW2Q65oKL7aRJmqEk/Exin-Website-Design
 */

import { FunctionComponent } from 'react';

import { PaletteColor } from '../../styling/AppStyles';

const WebsiteIcon: FunctionComponent = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 0H2C0.89 0 0 0.9 0 2V14C0 15.1 0.89 16 2 16H16C17.1 16 18 15.1 18 14V2C18 0.9 17.11 0 16 0ZM16 14H2V4H16V14Z"
      fill={PaletteColor.text}
    />
  </svg>
);

export default WebsiteIcon;
